import React from 'react';

const Footer = () => (
  <footer className="content-footer footer bg-footer-theme">
    <div className="container-fluid">
      <div className="footer-container d-flex align-items-center justify-content-between py-4 flex-md-row flex-column">
        <div className="text-body mb-2 mb-md-0">
          &copy; {new Date().getFullYear()}, Developed by <span className="text-danger"></span> 
          <a href="https://neusco.com/" target="_blank" className="footer-link">Neusco</a>
        </div>
        {/* <div className="d-none d-lg-inline-block">
          <a href="https://themeforest.net/licenses/standard" className="footer-link me-4" target="_blank">License</a>
          <a href="https://1.envato.market/pixinvent_portfolio" target="_blank" className="footer-link me-4">More Themes</a>
          <a href="https://demos.pixinvent.com/materialize-html-admin-template/documentation/" target="_blank" className="footer-link me-4">Documentation</a>
          <a href="https://pixinvent.ticksy.com/" target="_blank" className="footer-link d-none d-sm-inline-block">Support</a>
        </div> */}
      </div>
    </div>
  </footer>
);

export default Footer;
